import { useCallback } from 'react';
import { EntityIdInCard } from './EntityIdInCard';
import './ItemCard.scss';
import { LinkTo } from './LinkTo';

interface Props {
  children: JSX.Element;
  classes?: string;
  routerLink?: string;
  entityId?: number | string | null;
  index?: number;
}

export const ItemCard = ({ children, classes = '', routerLink = '', entityId = '', index }: Props) => {
  const getIdInCard = useCallback(() => {
    if (entityId) return <EntityIdInCard id={entityId} />;
  }, [entityId]);

  return (
    <LinkTo link={routerLink} data={{}} classes={`link-reset card ${classes}`} testId={`ItemCard_${index}`}>
      <>
        {getIdInCard()}
        {children}
      </>
    </LinkTo>
  );
};
